import React from 'react';

import { FormattedMessage } from 'react-intl';

import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import messages from './messages';

export default {
  id: 'closedDate',
  displayName: <FormattedMessage {...messages.closedDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS,
  filterValue: 'ClosedDateTime',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS, criteriaInformations);
  },
};
